import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import "./index.scss";

const ReportTemplateMaster = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [formData, setFormData] = useState({
    reportCode: "",
    reportName: "",
    reportCategory: "Operational",
    reportType: "Tabular",
    primaryTable: "",
    enableSchedule: false,
    frequency: "Daily",
    runTime: null,
    startDate: null,
    emailRecipients: "",
    outputFormats: ["pdf"]
  });

  const templates = [
    { title: "Daily Remittance Summary", code: "RPT001", category: "Operational", frequency: "Daily" },
    { title: "Monthly Settlement Report", code: "RPT002", category: "Financial", frequency: "Monthly" },
    { title: "Commission Analysis", code: "RPT003", category: "Analytical", frequency: "On-Demand" },
    { title: "Exception Report", code: "RPT004", category: "Control", frequency: "Weekly" },
    { title: "Aging Analysis", code: "RPT005", category: "Financial", frequency: "Monthly" },
    { title: "Electronic Transfer Log", code: "RPT006", category: "Operational", frequency: "Daily" }
  ];

  return (
    <div className="report-template-master">
      <Card title="Remittance Report Template Master">
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <TabPanel header="Report Templates">
            <div className="template-grid">
              {templates.map((template) => (
                <Card key={template.code} className="template-card">
                  <h4>{template.title}</h4>
                  <p>Code: {template.code}</p>
                  <p>Category: {template.category}</p>
                  <p>Frequency: {template.frequency}</p>
                  <div className="card-actions">
                    <Button icon="pi pi-pencil" className="p-button-text" />
                    <Button icon="pi pi-copy" className="p-button-text" />
                    <Button icon="pi pi-trash" className="p-button-text p-button-danger" />
                  </div>
                </Card>
              ))}
              <Card className="template-card add-new">
                <Button icon="pi pi-plus" label="Create New Template" className="p-button-text" />
              </Card>
            </div>
          </TabPanel>

          <TabPanel header="Report Designer">
            <div className="form-section">
              <h3>Report Configuration</h3>
              <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-6">
                  <label>Report Code *</label>
                  <InputText value={formData.reportCode} onChange={(e) => setFormData({ ...formData, reportCode: e.target.value })} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Report Name *</label>
                  <InputText value={formData.reportName} onChange={(e) => setFormData({ ...formData, reportName: e.target.value })} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Report Category *</label>
                  <Dropdown value={formData.reportCategory} options={[
                    { label: "Operational", value: "Operational" },
                    { label: "Financial", value: "Financial" },
                    { label: "Analytical", value: "Analytical" },
                    { label: "Control", value: "Control" },
                    { label: "Regulatory", value: "Regulatory" }
                  ]} onChange={(e) => setFormData({ ...formData, reportCategory: e.value })} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Report Type</label>
                  <Dropdown value={formData.reportType} options={[
                    { label: "Tabular", value: "Tabular" },
                    { label: "Summary", value: "Summary" },
                    { label: "Detailed", value: "Detailed" },
                    { label: "Matrix", value: "Matrix" },
                    { label: "Dashboard", value: "Dashboard" }
                  ]} onChange={(e) => setFormData({ ...formData, reportType: e.value })} />
                </div>
              </div>
            </div>
          </TabPanel>

          <TabPanel header="Schedule">
            <div className="form-section">
              <h3>Report Schedule</h3>
              <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-6">
                  <label>Enable Scheduling</label>
                  <div className="checkbox-wrapper">
                    <Checkbox checked={formData.enableSchedule} onChange={(e) => setFormData({ ...formData, enableSchedule: e.checked })} />
                    <label className="checkbox-label">Enable</label>
                  </div>
                </div>
                {formData.enableSchedule && (
                  <>
                    <div className="p-field p-col-12 p-md-6">
                      <label>Frequency</label>
                      <Dropdown value={formData.frequency} options={[
                        { label: "Daily", value: "Daily" },
                        { label: "Weekly", value: "Weekly" },
                        { label: "Monthly", value: "Monthly" },
                        { label: "Quarterly", value: "Quarterly" },
                        { label: "Yearly", value: "Yearly" }
                      ]} onChange={(e) => setFormData({ ...formData, frequency: e.value })} />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                      <label>Run Time</label>
                      <Calendar value={formData.runTime} onChange={(e) => setFormData({ ...formData, runTime: e.value })} timeOnly hourFormat="24" />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                      <label>Start Date</label>
                      <Calendar value={formData.startDate} onChange={(e) => setFormData({ ...formData, startDate: e.value })} dateFormat="yy-mm-dd" />
                    </div>
                  </>
                )}
              </div>
            </div>
          </TabPanel>
        </TabView>

        <div className="button-group mt-4">
          <Button label="Save" icon="pi pi-check" className="p-button-success" />
          <Button label="Cancel" icon="pi pi-times" className="p-button-secondary ml-2" />
        </div>
      </Card>
    </div>
  );
};

export default ReportTemplateMaster;
